/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon16Solid = forwardRef('BookClosedIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4a3 3 0 0 1 3-3h6.5A1.5 1.5 0 0 1 13 2.5v8a1.5 1.5 0 0 1-1.5 1.5H4.214a.75.75 0 0 0 .036 1.499h8a.75.75 0 0 1 0 1.5h-8a2.25 2.25 0 0 1-2.25-2.2V4Zm3 0a.5.5 0 0 0 0 1h5.5a.5.5 0 0 0 0-1H5Z" })));
});
